import { render } from "./MessengerDownloadLinks.vue?vue&type=template&id=0d35fb93"
import script from "./MessengerDownloadLinks.vue?vue&type=script&lang=js"
export * from "./MessengerDownloadLinks.vue?vue&type=script&lang=js"

import "./MessengerDownloadLinks.vue?vue&type=style&index=0&id=0d35fb93&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__